import {
  IAvailableEndpoint,
  IMcpToolUpdate
} from "../../interfaces/endpoints/IMcpTool";
import toast from "react-hot-toast";
import EndpointDropdown from "./EndpointDropdown";
import McpSchemaField from "./McpSchemaField";

type ChangeEvent = React.ChangeEvent<
  HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
>;

interface Props {
  form: IMcpToolUpdate;
  onChange: (e: ChangeEvent) => void;
  setForm: React.Dispatch<React.SetStateAction<IMcpToolUpdate>>;
  endpoints: IAvailableEndpoint[];
  onEndpointSelect: (ep: IAvailableEndpoint) => void;
  isEdit: boolean;
}

const McpToolForm: React.FC<Props> = ({
  form, onChange, setForm,
  endpoints, onEndpointSelect, isEdit
}) => {
  const formatSchema = () => {
    try {
      const parsed = JSON.parse(form.inputSchemaJson);
      const fmt = JSON.stringify(parsed, null, 2);
      setForm((p) => ({ ...p, inputSchemaJson: fmt }));
    } catch {
      toast.error("Invalid JSON");
    }
  };

  return (
    <div className="space-y-4">
      {isEdit ? (
        <div>
          <label className="block text-sm font-medium mb-1">
            Endpoint
          </label>
          <input
            name="endpoint" value={form.endpoint}
            onChange={onChange}
            className="w-full border rounded-md px-3 py-2 text-sm
              font-mono"
            required
          />
        </div>
      ) : (
        <EndpointDropdown
          endpoints={endpoints}
          onSelect={onEndpointSelect}
        />
      )}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">
            Tool Name
          </label>
          <input
            name="toolName" value={form.toolName}
            onChange={onChange}
            className="w-full border rounded-md px-3 py-2 text-sm"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">
            Category
          </label>
          <input
            name="category" value={form.category}
            onChange={onChange}
            className="w-full border rounded-md px-3 py-2 text-sm"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          Description
        </label>
        <textarea
          name="description" value={form.description}
          onChange={onChange}
          className="w-full border rounded-md px-3 py-2 text-sm"
          rows={3} required
        />
      </div>
      <McpSchemaField
        form={form}
        onChange={onChange}
        onFormat={formatSchema}
      />
    </div>
  );
};

export default McpToolForm;
